import { MoonstarEdit } from '../Moonstar/MoonstarEdit';
import { MoonstarEditForm } from '../Moonstar/MoonstarEditForm';
import { SimpleStack } from '../Moonstar/SimpleStack';
import { KpiInputs } from './KpiInputs';

export const KpiEdit = () => (
  <MoonstarEdit redirect="list" hideDelete>
    <MoonstarEditForm>
      <SimpleStack className="sm:w-full">
        <KpiInputs />
      </SimpleStack>
    </MoonstarEditForm>
  </MoonstarEdit>
);
